module.exports = __webpack_public_path__ + "static/media/slightlySmilingFace.d9a59639.png";